export default {
  direct: 'Direkte',
  stops: 'omstigninger',
  stop: 'omstigning',
}
